import { Component } from '@angular/core';
import { PortalBanner } from '../../models/portal-banner.interface';
import { ClaimService } from 'src/app/services/claim.service';
import { LoginService } from 'src/app/services/login.service';

@Component({
  selector: 'upsc-happy-returns-layout',
  templateUrl: './happy-returns-layout.component.html',
  styleUrls: ['./happy-returns-layout.component.scss']
})
export class HappyReturnsLayoutComponent {

  flowType: string = '';
  portalType: string = '';
  partnerName: string = '';
  userDetails: any = {};
  isDynamicOutage: boolean = false;
  portalBanner: PortalBanner | null = null;
  countryLocale: string = 'en';

  constructor(private claimService: ClaimService,
      private loginService: LoginService) { }

  public ngOnInit(): void {
    this.flowType = sessionStorage.getItem("flowType")!;
    this.userDetails = JSON.parse(sessionStorage.getItem('userDetails')!);
    if (this.userDetails?.type?.trim()) {
      this.portalType = this.userDetails.type;
    }

    this.getBanner();
  }

  private setBannerVisibility(): void {

    if (!this.portalBanner) {
      this.isDynamicOutage = false;
      return;
    }

    const now = new Date();
    const startTime = new Date(this.portalBanner.startTime);
    const endTime = new Date(this.portalBanner.endTime);

    this.isDynamicOutage =
      now >= startTime &&
      now <= endTime;
  }

  getBanner() {

    const bannerDismissed = sessionStorage.getItem('portalBannerDismissed');
    if (bannerDismissed === 'true') {
      this.isDynamicOutage = false;
      return;
    }

    const cachedBanner = sessionStorage.getItem('portalBanner');

    if (cachedBanner) {
      this.portalBanner = JSON.parse(cachedBanner);
      this.setBannerVisibility();
      return;
    }

    if (this.portalType === 'customized-claims-portal') {
      this.portalType = 'CCP';
      this.partnerName = this.flowType === 'customized-claims-portal' ? 'unishippers'
        : this.flowType === 'pirateship'
          ? 'pirate-ship' : this.flowType;
    }

    const policyNumber = this.loginService.getPolicyDetails()?.policyNumber!;
    this.claimService
      .getPolicyBanners(this.portalType, policyNumber, this.partnerName, this.countryLocale)
      .subscribe(response => {

        const banner = response?.data?.portalBanners?.[0];

        if (banner) {

          this.portalBanner = {
            messageText: banner.messageText,
            startTime: banner.startTime,
            endTime: banner.endTime
          };

          sessionStorage.setItem(
            'portalBanner',
            JSON.stringify(this.portalBanner)
          );

          this.setBannerVisibility();
        } else {
          this.isDynamicOutage = false;
        }
      });
  }

  onBannerClosed(): void {
    this.isDynamicOutage = false;
    sessionStorage.setItem('portalBannerDismissed', 'true');
  }


}
